import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "@/components/home";

// Lazy load non-critical routes to reduce initial bundle size
const Support = lazy(() => import("@/components/Support"));
const PrivacyPolicy = lazy(() => import("@/components/PrivacyPolicy"));
const Terms = lazy(() => import("@/components/Terms"));
const LeadershipPage = lazy(() => import("@/components/LeadershipPage"));
const Blog = lazy(() => import("@/components/Blog"));
const BlogPost = lazy(() => import("@/components/BlogPost"));

// Loading fallback component
function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-neutral-500 text-lg font-light">Loading...</div>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/leadership" element={<LeadershipPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Suspense>
  );
}

export default App;